import { render, staticRenderFns } from "./TableScrollContainer.vue?vue&type=template&id=51fdb06e&"
import script from "./TableScrollContainer.vue?vue&type=script&lang=js&"
export * from "./TableScrollContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports